// extracted by mini-css-extract-plugin
export default {"table-top-field":"YchhuOz6dhZyF2Re_ron","table-top-left-field":"vC_M9BToippLQDnLXX4Y","table-top-right-field":"Fw_cmMlsewCr2IcEHFt1"};